import React, { FC } from "react";
import Logo from "shared/Logo/Logo";
import MenuBar from "shared/MenuBar/MenuBar";
import AvatarDropdown from "./AvatarDropdown";
import Navigation from "shared/Navigation/Navigation";
import { useNavigate } from "react-router-dom";

import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useIsMobile } from "hooks/useIsMobile";
import NotificationsDropDown from "./NotificationsDropDown";

export interface MainNav2LoggedProps {}

const MainNav2Logged: FC<MainNav2LoggedProps> = () => {
  const navigate = useNavigate();

  const { isMobile } = useIsMobile(0, 0);

  const renderContent = () => {
    return (
      <div className="h-20 flex justify-between">
        <div className="flex items-center lg:hidden flex-1">
          <MenuBar />
        </div>

        <div className="lg:flex-1 flex items-center">
          <Logo className="flex-shrink-0" />
        </div>

        <div className="flex-[3] hidden lg:flex justify-center mx-4">
          <Navigation />
        </div>

        <div className="flex-1 flex items-center justify-end text-slate-700 dark:text-slate-100">
          <>
            <div className="flex justify-center gap-2 mr-5">
              {!isMobile ? (
                <>
                  <div className="badgeContainer">
                    <div className="badge">
                      <span className="badgeTxt">5</span>
                    </div>
                    <MailOutlineIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/messenger")}
                    />
                  </div>
                  <div className="line" />
                </>
              ) : null}

              <div className="badgeContainer">
                <div className="badge">
                  <span className="badgeTxt">12</span>
                </div>
                <NotificationsDropDown />
              </div>
            </div>
          </>

          <AvatarDropdown />
        </div>
      </div>
    );
  };

  return (
    <div className="nc-MainNav2Logged relative z-10 bg-white dark:bg-neutral-900 border-b border-slate-100 dark:border-slate-700">
      <div className="container ">{renderContent()}</div>
    </div>
  );
};

export default MainNav2Logged;
